import axios from 'axios';

// Get the base URL from environment variables
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';
const APP_BASE_PATH = process.env.PUBLIC_URL || '';

const buildAppPath = (path) => {
    if (!APP_BASE_PATH) {
        return path;
    }
    return `${APP_BASE_PATH}${path}`;
};

// Create axios instance with default configuration
const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000, // 30 seconds
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add authentication token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('vendor_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle common error scenarios
        if (error.response) {
            // Server responded with error status
            const { status, data } = error.response;
            
            switch (status) {
                case 401: {
                    // Public auth calls (login/OTP) report errors on the page; redirecting would reload it and hide the message.
                    const url = error.config?.url || '';
                    const publicAuthEndpoints = [
                        '/auth/vendor/login',
                        '/auth/vendor/verify-otp',
                        '/auth/vendor/resend-otp',
                    ];
                    const isPublicAuth = publicAuthEndpoints.some((p) => url.includes(p));
                    const hadToken = !!localStorage.getItem('vendor_token');

                    if (!isPublicAuth && hadToken) {
                        localStorage.removeItem('vendor_token');
                        window.location.href = buildAppPath('/login');
                    }
                    break;
                }
                case 403:
                    // Forbidden - show access denied message
                    console.error('Access denied:', data.message);
                    break;
                case 500:
                    // Server error
                    console.error('Server error:', data.message);
                    break;
                default:
                    console.error('API Error:', data.message || 'Unknown error occurred');
            }
            
            // Return a structured error object
            return Promise.reject({
                status,
                message: data.detail || data.message || 'An error occurred',
                data: data
            });
        } else if (error.request) {
            // Network error
            console.error('Network error:', error.message);
            return Promise.reject({
                status: 0,
                message: 'Network error. Please check your connection.',
                data: null
            });
        } else {
            // Other error
            console.error('Error:', error.message);
            return Promise.reject({
                status: 0,
                message: error.message || 'An unexpected error occurred',
                data: null
            });
        }
    }
);

export default api; 